import { Dispatch } from 'react';
import {
  Control,
  FieldErrors,
  UseFormClearErrors,
  UseFormGetValues,
  UseFormRegister,
  UseFormSetValue,
} from 'react-hook-form';
import { IFilter } from '.';
import APIS from '../../constant/Endpoint';
import ComboboxFilter from '../Reusable/ComboboxFilter';
import DateRangePicker from '../Reusable/DateRangePicker';
import { ClientAccessControl } from '@careinfo/permission-required';

interface Props {
  register: UseFormRegister<IFilter>;
  setValue: UseFormSetValue<IFilter>;
  getValues: UseFormGetValues<IFilter>;
  clearErrors: UseFormClearErrors<IFilter>;
  errors: FieldErrors<IFilter>;
  control: Control<IFilter, any>;
  setDate: Dispatch<any>;
  adminOnly: boolean;
}

const Filter = ({
  register,
  errors,
  setValue,
  getValues,
  clearErrors,
  setDate,
  adminOnly,
  control,
}: Props) => {
  return (
    <>
      <ClientAccessControl
        allowedPermissions={['can_edit_overview_filter']}
        renderNoAccess={
          <>
            <ComboboxFilter<IFilter>
              url={APIS.BRANCH}
              disabled={true}
              queryKey={'branch'}
              name={'pickup_branch'}
              control={control}
              label={'From Branch'}
              params={{
                is_active: true,
              }}
              placeholder={'Select Branch'}
            />
            <ComboboxFilter<IFilter>
              url={APIS.BRANCH}
              disabled={true}
              queryKey={'to-branch'}
              name={'to_branch'}
              control={control}
              label={'To Branch'}
              params={{
                is_active: true,
              }}
              placeholder={'Select Branch'}
            />
            <ComboboxFilter<IFilter>
              url={APIS.LOCATION}
              disabled={true}
              queryKey={'barnch'}
              params={{ level: 3, is_active: true }}
              name={'destination'}
              control={control}
              label={'Destination City'}
              placeholder={'Select Destination City'}
            />
            <ComboboxFilter<IFilter>
              url={APIS.STAFF}
              disabled={true}
              queryKey={'staff'}
              params={{ is_staff: true, is_active: true }}
              name={'staff'}
              control={control}
              label={'Staff'}
              placeholder={'Select Staff'}
            />
            <ComboboxFilter<IFilter>
              url={APIS.CUSTOMER}
              disabled={true}
              queryKey={'customer'}
              name={'sender'}
              control={control}
              label={'Sender'}
              params={{
                is_active: true,
              }}
              placeholder={'Select Sender'}
            />
            <ComboboxFilter<IFilter>
              url={APIS.MERCHANT}
              disabled={true}
              queryKey={'vendor'}
              name={'vendor'}
              control={control}
              label={'Merchant'}
              params={{
                is_active: true,
              }}
              placeholder={'Select Merchant'}
            />
            <DateRangePicker
              label={'Select Date Range'}
              setValue={setValue}
              name={'date_range'}
              disabled={true}
              getValues={getValues}
              setDate={setDate}
            />
          </>
        }
      >
        <ComboboxFilter<IFilter>
          url={APIS.BRANCH}
          queryKey={'branch'}
          name={'pickup_branch'}
          control={control}
          label={'From Branch'}
          params={{
            is_active: true,
          }}
          placeholder={'Select Branch'}
        />
        <ComboboxFilter<IFilter>
          url={APIS.BRANCH}
          queryKey={'to-branch'}
          name={'to_branch'}
          control={control}
          label={'To Branch'}
          params={{
            is_active: true,
          }}
          placeholder={'Select Branch'}
        />
        <ComboboxFilter<IFilter>
          url={APIS.LOCATION}
          queryKey={'barnch'}
          params={{ level: 3, is_active: true }}
          name={'destination'}
          control={control}
          label={'Destination City'}
          placeholder={'Select Destination City'}
        />
        <ComboboxFilter<IFilter>
          url={APIS.STAFF}
          queryKey={'staff'}
          params={{ is_staff: true, is_active: true }}
          name={'staff'}
          control={control}
          label={'Staff'}
          placeholder={'Select Staff'}
        />
        <ComboboxFilter<IFilter>
          url={APIS.CUSTOMER}
          queryKey={'customer'}
          name={'sender'}
          control={control}
          label={'Sender'}
          params={{
            is_active: true,
          }}
          placeholder={'Select Sender'}
        />
        <ComboboxFilter<IFilter>
          url={APIS.MERCHANT}
          queryKey={'vendor'}
          name={'vendor'}
          control={control}
          label={'Merchant'}
          params={{
            is_active: true,
          }}
          placeholder={'Select Merchant'}
        />
        <DateRangePicker
          label={'Select Date Range'}
          setValue={setValue}
          name={'date_range'}
          getValues={getValues}
          setDate={setDate}
        />
      </ClientAccessControl>
    </>
  );
};

export default Filter;
